export class OuterParameter {
    public guid: string;
    public action: string;

    constructor(guid: string, action: string) {
        this.guid = guid;
        this.action = action;
    }
}
